"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderChildren2d = exports.orderChildren = exports.getLayout = undefined;

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _lodash = require("lodash");

var _GridLayout = require("./GridLayout");

var _GridLayout2 = _interopRequireDefault(_GridLayout);

var _ListLayout = require("./ListLayout");

var _ListLayout2 = _interopRequireDefault(_ListLayout);

var _FormLayout = require("./FormLayout");

var _FormLayout2 = _interopRequireDefault(_FormLayout);

var _TabLayout = require("./TabLayout");

var _TabLayout2 = _interopRequireDefault(_TabLayout);

var _PagesLayout = require("./PagesLayout");

var _PagesLayout2 = _interopRequireDefault(_PagesLayout);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var layouts = {
  "grid": _GridLayout2.default,
  "list": _ListLayout2.default,
  "form": _FormLayout2.default,
  "tabs": _TabLayout2.default,
  "pages": _PagesLayout2.default
};

var indexInRow = function indexInRow(key, row) {
  return (0, _lodash.indexOf)(row, key);
};

var indexOfRow = function indexOfRow(key, rows) {
  return (0, _lodash.findIndex)(rows, function (row) {
    return indexInRow(key, row) >= 0;
  });
};

var findRowColumn = function findRowColumn(key, rows) {
  var row = indexOfRow(key, rows);
  var column = row >= 0 ? indexInRow(key, rows[row]) : -1;
  return [row, column];
};

var orderChildren2d = function orderChildren2d(values, order) {
  order = (0, _lodash.map)(order, function (entry) {
    return (0, _lodash.isArray)(entry) ? entry : [entry];
  });
  var rows = [];
  (0, _lodash.forEach)(values, function (value) {
    var key = value.key;

    var _findRowColumn = findRowColumn(key, order),
        _findRowColumn2 = (0, _slicedToArray3.default)(_findRowColumn, 2),
        row = _findRowColumn2[0],
        column = _findRowColumn2[1];

    if (row >= 0 && column >= 0) {
      rows[row] = rows[row] || [];
      rows[row][column] = value;
    } else {
      rows.push([value]);
    }
  });
  return rows;
};

var orderChildren = function orderChildren(values) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var orderedChildren = Array(order.length);
  (0, _lodash.forEach)(values, function (value) {
    var key = value.key;
    var index = (0, _lodash.indexOf)(order, key);

    if (index >= 0) {
      orderedChildren[index] = value;
    } else {
      orderedChildren.push(value);
    }
  });
  return (0, _lodash.compact)(orderedChildren);
};

var getLayout = function getLayout(layout, defaultTo) {
  layout = layout || defaultTo;
  var name = layout.type || layout;
  var result = layouts[name] || layouts[defaultTo];
  return result;
};

exports.getLayout = getLayout;
exports.orderChildren = orderChildren;
exports.orderChildren2d = orderChildren2d;
exports.default = layouts;